import React from "react";
import StudentsTable from "../components/studentslist/StudentsTable";
export default function RoomSessionTable() {
    return <StudentsTable mode={2} room={window.location.pathname.split("/").pop()}/>;
}
